import { useTranslation } from '@frontend/i18n';
import { MessageTemplate, TagType, Text } from '@frontend/design-system';
import { Card } from './Card';

type Props = {
  template: string;
  templateTags: TagType[];
  isReadOnlyTemplate: boolean;
  onTemplateChange: (template: string) => void;
};

export const ApprovalMessageCard = ({ template, templateTags, isReadOnlyTemplate, onTemplateChange }: Props) => {
  const { t } = useTranslation('scheduleCalendarRequest');

  return (
    <Card title={t('Approval Message')}>
      <MessageTemplate
        initialTemplate={template}
        tags={templateTags}
        draggableTags
        onChange={onTemplateChange}
        readOnly={isReadOnlyTemplate}
      >
        <MessageTemplate.Editor />
        <Text weight='light' color='light'>
          {t('You can also drag and drop, or click a tag below, to add your message')}
        </Text>
        <MessageTemplate.TagList />
      </MessageTemplate>
    </Card>
  );
};
